import type { PurchaseOrder } from '@ztechapps/common.contract'
import isEmpty from 'lodash/isEmpty'
import { roundNumber } from '@ztechapps/common.utils'
import sumBy from 'lodash/sumBy'

/**
 * This will include the calculations for shipping fee, which will query from the shipping gateway
 * Every change in order items will change the weight thus will change the shipping fee amount
 */
export async function computePurchaseOrderAmount(order: PurchaseOrder): Promise<{ net: number; gross: number }> {
  if (isEmpty(order?.items)) return { net: 0, gross: 0 }

  //the gross is just the sum of the items
  const gross = roundNumber(sumBy(order?.items, 'net'), 2)

  const taxAmount = order?.taxAmount ?? 0,
    discount = order?.discount ?? 0

  const net = roundNumber(gross + taxAmount - discount, 2)
  return {
    net,
    gross,
  }
}
